/* eslint-env node */
const currentUrlIsStaging = () =>
  typeof window !== "undefined" &&
  (`${window.location.href}`.startsWith("https://staging") ||
    window.location.hostname.endsWith(".netlify.com"));

export const isDevelopment =
  process.env.NODE_ENV === "development" ||
  process.env.NODE_ENV === "test" ||
  currentUrlIsStaging();

const developmentConstants = {
  API_BASE_URL: "https://api.compfest.id",
  API_WORDPRESS_URL:
    "https://public-api.wordpress.com/rest/v1.1/sites/127093287",
};

const productionConstants = {
  API_BASE_URL: "https://api.compfest.id",
  API_WORDPRESS_URL:
    "https://public-api.wordpress.com/rest/v1.1/sites/127093287",
};

export default (isDevelopment ? developmentConstants : productionConstants);
